import React, { useEffect, useState } from "react";
import TableContext from "./tableContext";
import Views from "./views";
import { addSearchValue } from "@HELPERS";

import "./index.scss";

const DataTable = (props) => {
  const [searchSelectedValues, setSearchSelectedValues] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState(props.dataSource);

  useEffect(() => {
    if (typeof props.dataSource === "object" && props.dataSource.length > 0) {
      const arr = props.dataSource.map((item) => ({
        ...item,
        searchValues: props?.searchKeys
          ? addSearchValue(props.searchKeys, item)
          : null,
      }));
      setDataSource(arr);
    } else {
      setDataSource([]);
    }
  }, [props]);

  return (
    <div className="master-data-table">
      <TableContext.Provider
        value={{
          props,
          dataSource,
          columns: props.columns,
          excelColumns: props.excelColumns,
          refresh: props.refresh,
          name: props.name,
          searchKeys: props.searchKeys,
          searchSelectedValues,
          loading: props.loading || loading,
          /*
          handleClick: (row) =>
            typeof props.handleClick === 'function' && props.handleClick(row),
            */
          setLoading: (val) => setLoading(val),
          search: (val) => setSearchSelectedValues(val),
          mutate: async () => {
            setLoading(true);
            await props.mutate();
            setLoading(false);
          },
        }}
      >
        <Views />
      </TableContext.Provider>
    </div>
  );
};

export default DataTable;
